/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { showToast } from 'vant';
import { useEmptyStringFormat } from '@/hooks/fn';
import { LineEchart } from '@/components/page-echarts';
import { updateDowntimeReason } from '@/service/production/proReportAggregate/index';
export default defineComponent({
  name: 'DowntimeDetail',
  components: {
    LineEchart: LineEchart
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  emits: ['update'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var emptyStringFormat = useEmptyStringFormat();
    var status = ref(true);
    var downtimeReason = ref('');
    var toWrite = function toWrite() {
      status.value = false;
    };
    var submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(downtimeReason.value === '')) {
                _context.next = 3;
                break;
              }
              showToast('请输入停机原因');
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return updateDowntimeReason({
                status: props.item.status,
                dayTime: props.item.dayTime,
                openCloseTime: props.item.openCloseTimeQuery,
                msg: downtimeReason.value
              });
            case 5:
              data = _context.sent;
              emit('update');
              showToast(data);
              status.value = true;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref2.apply(this, arguments);
      };
    }();
    var saleTrend = computed(function () {
      var list = props.item.currentTrend.map(function (item) {
        return item.value;
      });
      var xLabels = props.item.currentTrend.map(function (item) {
        return item.name.split(' ')[1];
      });
      return {
        lineData: list,
        xLabels: xLabels,
        legendData: [''],
        yName: "",
        grid: {
          top: '25',
          left: '10',
          right: '0',
          bottom: '5',
          containLabel: true
        },
        height: '180px'
        // axisLabelRotate:60,
      };
    });
    return {
      emptyStringFormat: emptyStringFormat,
      status: status,
      downtimeReason: downtimeReason,
      toWrite: toWrite,
      submit: submit,
      saleTrend: saleTrend
    };
  }
});